// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isUndefinedOrNull = (value: any): boolean =>
  value === undefined || value === null || value === '';
